import { Pipe, PipeTransform, NgModule, inject } from '@angular/core';
import { ConfigService } from '@assist/shared/data';
import { CalendarAvailability } from '@cue/calendars';

@Pipe({
  name: 'availabilityColor',
  standalone: true,
})
export class AvailabilityColorPipe implements PipeTransform {
  private configService = inject(ConfigService);

  transform(availability: CalendarAvailability, ...args: unknown[]): string {
    return this.configService.backgroundColor(availability);
  }
}
